import { Content } from 'antd/lib/layout/layout';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { Button, Dropdown, Menu, Row, Tag, Typography } from 'antd';
import Col from 'antd/es/grid/col';
import { SettingOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { CommonTable } from 'components/CommonTable/CommonTable';
import { SignedAgreementsItem } from 'store/slices/signedAgreements/interfaces';
import {
  Statuses,
  statusesColorsHash,
  statusesNamesHash,
} from 'constants/status';
import { FileIcon } from 'components/FileIcon';

import styles from './TableAgreements.module.less';

interface TableAgreementsProps {
  total: number;
  getActions: (item: SignedAgreementsItem) => ItemType[];
  setSort: (sort?: string) => void;
  limit: number;
  items?: SignedAgreementsItem[];
}

export const TableAgreements = ({
  getActions,
  total,
  limit,
  items = [],
  setSort,
}: TableAgreementsProps) => {
  const columns: ColumnsType<TODO_ANY> = [
    {
      key: 'name',
      title: 'Название',
      sorter: true,
      dataIndex: 'name',
      render: (text: string, { id }) => (
        <Link to={`/signedAgreements/${id}/edit`} title={text}>
          <Row gutter={[12, 0]}>
            <Col>
              <FileIcon />
            </Col>
            <Col style={{ overflow: 'hidden', flex: '1 0' }}>
              <Typography.Text>{text || 'Без названия'}</Typography.Text>
            </Col>
          </Row>
        </Link>
      ),
    },
    {
      key: 'month',
      title: 'Месяц',
      sorter: true,
      width: 100,
      dataIndex: 'month',
      render: (month: number) => (
        <Typography.Text style={{ textTransform: 'capitalize' }}>
          {dayjs().locale('ru').month(month).format('MMMM')}
        </Typography.Text>
      ),
    },
    {
      key: 'year',
      title: 'Год',
      sorter: true,
      dataIndex: 'year',
      width: 100,
    },
    {
      key: 'status',
      title: 'Статус',
      dataIndex: 'status',
      width: '20%',
      render: (status: Statuses) => (
        <Tag color={statusesColorsHash[status]}>
          {statusesNamesHash[status]}
        </Tag>
      ),
    },
    {
      key: 'actions',
      title: '',
      width: 65,
      dataIndex: 'actions',
      fixed: 'right',
      render: (_: unknown, item: SignedAgreementsItem) => (
        <Dropdown
          placement='bottomRight'
          overlay={
            <Menu className={styles.actionDropdown} items={getActions(item)} />
          }
          arrow
          trigger={['click']}
        >
          <Button type='text' icon={<SettingOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <Content>
      <CommonTable
        columns={columns}
        scroll={{ x: 800 }}
        total={total}
        limit={limit}
        dataSource={items}
        setSort={setSort}
      />
    </Content>
  );
};
